import { SearchResultDetails } from "@cruisen/contract"
import { callFirebaseFunction } from "../callFirebaseFunction"
//import { reportLog } from "../../utils/feedback/crashReporting"

export const getCruiseDetails = async (
  tripId: string,
  cruiseId: string,
  tripSearchId: string,
): Promise<SearchResultDetails | null> => {
  console.log("get cruise details", {
    tripId,
    tripSearchId,
    tripSearchResultId: cruiseId,
  })
  const response = await callFirebaseFunction({
    name: "tripSearchResultDetails",
    payload: { tripId, tripSearchId, tripSearchResultId: cruiseId },
  })

  if (response.error) throw new Error(response.message)

  return {
    ...response.data,
    itineraryItems: response.data.itineraryItems.sort((a, b) => a.day - b.day),
  }
}
